/* eslint-disable no-use-before-define */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    erFeltMedEgenskaper: function() {
        return erFeltMedEgenskaper;
    },
    erFelt: function() {
        return erFelt;
    },
    erFeltEllerFeltMedEgenskaper: function() {
        return erFeltEllerFeltMedEgenskaper;
    },
    erFeltgruppe: function() {
        return erFeltgruppe;
    },
    erKorttype: function() {
        return erKorttype;
    },
    erKortgruppe: function() {
        return erKortgruppe;
    },
    erTema: function() {
        return erTema;
    },
    erRepeterendeFelt: function() {
        return erRepeterendeFelt;
    },
    erDynamiskFelt: function() {
        return erDynamiskFelt;
    },
    erDynamiskGruppe: function() {
        return erDynamiskGruppe;
    },
    erFlerFeltVisning: function() {
        return erFlerFeltVisning;
    },
    erVerdiFelt: function() {
        return erVerdiFelt;
    },
    erFeltMedTransformer: function() {
        return erFeltMedTransformer;
    },
    erFeltMedOpsjon: function() {
        return erFeltMedOpsjon;
    },
    erFeltMedSkjulIKortDialog: function() {
        return erFeltMedSkjulIKortDialog;
    }
});
var erFeltMedEgenskaper = function(item) {
    return item.type === "feltMedEgenskaper";
};
var erFelt = function(item) {
    return item.type === "felt";
};
var erFeltEllerFeltMedEgenskaper = function(item) {
    return erFelt(item) || erFeltMedEgenskaper(item);
};
var erFeltgruppe = function(item) {
    return item.type === "feltgruppe";
};
var erKorttype = function(item) {
    return item.type === "korttype";
};
var erKortgruppe = function(item) {
    return item.type === "kortgruppe";
};
var erTema = function(item) {
    return item.type === "tema";
};
var erRepeterendeFelt = function(item) {
    return item.type === "repeterendefelt";
};
var erDynamiskFelt = function(item) {
    return item.type === "dynamiskfelt";
};
var erDynamiskGruppe = function(item) {
    return item.type === "dynamiskgruppe";
};
var erFlerFeltVisning = function(item) {
    return item.type === "flerFeltVisning";
};
var erVerdiFelt = function(item) {
    return erFelt(item) || erFeltMedEgenskaper(item) || erRepeterendeFelt(item) || erDynamiskFelt(item);
};
var erFeltMedTransformer = function(item) {
    return erFelt(item) || erFeltgruppe(item);
};
var erFeltMedOpsjon = function(definisjon) {
    return !!definisjon.opsjon;
};
var erFeltMedSkjulIKortDialog = function(definisjon) {
    return definisjon.skjulIKort !== undefined || definisjon.skjulIDialog !== undefined;
};
